import styled from '@emotion/styled';
import PropTypes from 'react-proptypes';
import {useDispatch, useSelector} from 'react-redux';
import {sync} from 'shared/wizard/actions';
import {Checkbox, CurrencyInput} from './';

const Container = styled.div`
  width: 100%;
  > div:first-of-type {
    display: flex;
  }
`;

const CheckboxWithCurrencyInput = ({ name, children, label, placeholder, ...props }) => {
  const dispatch = useDispatch();
  const {
    input,
    output: { errors },
  } = useSelector(state => state);
  return (
    <Container {...props}>
      <div>
        <Checkbox
          name={`has_${name}`}
          value={input[`has_${name}`]}
          onChange={sync(dispatch)(`has_${name}`)}
          label={label}
        />
        {children}
      </div>
      {input[`has_${name}`] && (
        <CurrencyInput
          id={name}
          onChange={sync(dispatch)(name)}
          value={input[name]}
          errors={errors[name]}
          placeholder={placeholder}
        />
      )}
    </Container>
  );
};

CheckboxWithCurrencyInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

CheckboxWithCurrencyInput.defaultProps = {
  label: '',
  placeholder: 'Bedrag',
};

export default CheckboxWithCurrencyInput;
